import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import CategoryGrid from "./components/CategoryGrid";
import SeoContent from "./components/SeoContent";
import ArticlePreviews from "./components/ArticlePreviews";
import CtaSection from "./components/CtaSection";
import JsonLd from "@/components/base/JsonLd";

const siteUrl = import.meta.env.VITE_SITE_URL || "https://mulebuyspreadsheet.my";

const homeJsonLd = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "WebSite",
      "name": "Mulebuy Spreadsheet",
      "url": siteUrl,
      "description": "The ultimate mulebuy spreadsheet system for smart buying and product tracking. Structured guides, comparisons, and educational resources for product sourcing.",
      "potentialAction": {
        "@type": "SearchAction",
        "target": {
          "@type": "EntryPoint",
          "urlTemplate": `${siteUrl}/search?q={search_term_string}`
        },
        "query-input": "required name=search_term_string"
      }
    },
    {
      "@type": "Organization",
      "name": "Mulebuy Spreadsheet",
      "url": siteUrl,
      "description": "Informational platform focused on educational content around the mulebuy spreadsheet system. We provide structured guides, comparisons, and educational resources.",
      "sameAs": [
        "https://kaspreadsheet.com/"
      ]
    }
  ]
};

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <SeoContent />
        <ArticlePreviews />
        <CtaSection />
      </main>
      <Footer />
      <JsonLd data={homeJsonLd} />
    </div>
  );
}